import axios from "axios";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Spinner from "../../src/spinner/index"
import { Button, Card, CardHeader, Col } from "reactstrap";
import { configuration } from "../appConfig";
import Slider from "react-slick";
import DriveNscanLogo from "../../src/assets/img/brand/dashboard-error-logo.png";
import CarDentPositionTable from "../carbodyparts/CarDentPositionTable";
import NewCarDentPositionTable from "../carbodyparts/NewCarDentPositionTable";
import "./NewPartDetails.css";
import { connect } from "react-redux";
import Swal from "sweetalert2";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default class NewPartDetails extends Component {
  constructor(props) {
    super(props);
    this.ExtraImage = React.createRef(null);
    this.state = {
    words: {},
    lang: "En",
    loader: false,
    uploadImgLoader: false,
    imagesModalCurrentSourceName: "",
    imageIndex: 0,
    imageName: [],
    data: [],
    imageSrc: "",
    dentEditorModal : false,
  };
  }
  componentDidMount() {
    this.getData();
    this.getLang();
    this.getScanImages();
  }

  // getScanImages = async () => {
  //   const partnerId = localStorage.getItem("partnerId");
  //   const selectedFile = localStorage.getItem("selectedFile");
  //   const { partName } = this.props.location.state;
  //   const client = localStorage.getItem("client")
  //   let partsToFetch
  //   if (client == "DNS") {
  //     partsToFetch = [partName]
  //   } else {
  //     partsToFetch = partName === "TrunkCover" ? ["Trunk", "TrunkCover"] : [partName];
  //   }

  //   this.setState({ [partName]: [] });

  //   try {
  //     let images = [];
  //     for (let part of partsToFetch) {
  //       const response = await axios.get(configuration.getScanImages, {
  //         params: {
  //           partnerId: partnerId,
  //           vin: selectedFile,
  //         },
  //       });

  //       if (response && response.data) {
  //         // if (this.props.toggleReportDamageImage == true && configuration.imagePath == "https://backend.drivenscan.live") {
  //         //   images = images.concat(response.data[`${part}_damage`]);
  //         // } else {
  //           images = images.concat(response.data[part]);
  //           console.log("images", images);
            
  //           console.log(part);
            
  //         // }
  //       }
  //     }

  //     if (images.length > 0) {
  //       this.setState({ [partName]: images });

  //       let splitPartName = images[0]
  //         .split("/")
  //       [images[0].split("/").length - 1].split(".")[0];
  //       this.setState({ imagesModalCurrentSourceName: splitPartName }, () => {
  //         this.getBase64Url();
  //         this.getImageName();
  //       });
  //     }
  //   } catch (error) {
  //     console.error("Error fetching scan images:", error);
  //   }
  // };

  getScanImages = async () => {
    const partnerId = localStorage.getItem("partnerId");
    const selectedFile = localStorage.getItem("selectedFile");
    const { partName } = this.props.location.state;
    const client = localStorage.getItem("client")
    this.setState({ [partName]: [] });
    try {
      let images = [];
        const response = await axios.get(configuration.getScanImages, {
          params: {
            partnerId: partnerId,
            vin: selectedFile,
          },
        });

        if (response && response.data) {
          // if (this.props.toggleReportDamageImage == true && configuration.imagePath == "https://backend.drivenscan.live") {
          //   images = images.concat(response.data[`${part}_damage`]);
          // } else {
          if (client !== "DNS" && partName === "TrunkCover") {
            images = images.concat(...response.data[partName],...response.data["Trunk"]);
          } else {
            images = images.concat(response.data[partName]);
          }
          // }
        }

      if (images.length > 0) {
        this.setState({ [partName]: images });

        let splitPartName = images[0]
          .split("/")
        [images[0].split("/").length - 1].split(".")[0];
        if (splitPartName)
          {
            this.setState({ imagesModalCurrentSourceName: splitPartName }, () => {
              this.getBase64Url();
              this.getImageName();
            });
        }
      }
    } catch (error) {
      console.error("Error fetching scan images:", error);
    }
  };


  getLang = () => {
    const base_url = window.location.origin;
    axios.get(`${base_url}/lang.json`).then((res) => {
      this.setState({
        words: res.data,
        lang: localStorage.getItem("lang"),
      });
    });
  };
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    } else return null;
  }

  lang = (word) => {
    const { lang, words } = this.state;
    return words[word] ? words[word][lang] : word;
  };

  handleBeforeChange = (oldIndex, newIndex) => {
    const { imageName } = this.state;
    const getImageName =
      imageName &&
      imageName.length > 0 &&
      imageName.find((name, index) => {
        return index == newIndex;
      });
    this.setState(
      { imagesModalCurrentSourceName: getImageName, imageIndex: newIndex },
      () => {
        this.getBase64Url();
      }
    );
  };

  getImageName = () => {
    const { partName } = this.props.location.state;
    const client = localStorage.getItem("client")
    let partsToFetch
    if (client == "DNS") {
      partsToFetch = [partName]
    } else {
      partsToFetch = partName === "TrunkCover" ? ["Trunk", "TrunkCover"] : [partName];
    }
    let name = [];

    for (let part of partsToFetch) {
      name = name.concat(
        this.state[part] &&
          Array.isArray(this.state[part]) &&
          this.state[part].length > 0
          ? this.state[part]
            .filter((url) => url && url.trim() !== "")
            .map((url) => {
              return url.split("/").pop().split(".")[0];
            })
          : []
      );
    }

    this.setState({ imageName: name });
  };

  getData = async () => {
    axios
      .get(
        `${configuration.getData}?vin=${localStorage.getItem(
          "selectedFile"
        )}&partnerId=${localStorage.getItem("partnerId")}`
      )
      .then((r) => {
        if (r.data) {
          this.setState({ data: r.data });
        }
      });
  };

  getBase64Url = async () => {
    this.setState({ loader: true });
    const partner_id = localStorage.getItem("partnerId");
    const vin_number = localStorage.getItem("selectedFile");
    const { imagesModalCurrentSourceName } = this.state;
    let img_name;

    const response = await axios.get(configuration.getBase64, {
      params: {
        partner_id,
        vin_number,
        img_name: imagesModalCurrentSourceName,
      },
    });
    if (response !== undefined) {
      this.setState({
        ...this.state,
        data64Url: response.data.base64_img,
        loader: false,
      });
    } else {
      this.setState({ loader: false });
    }
  };

  convertBase64 = async (file) => {
    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = async function () {
        resolve(reader.result);
      };
      reader.onerror = function (error) {
        reject(error);
      };
    });
  };
  capture = async (e) => {
    const { files } = e.target;
    const base64 = await this.convertBase64(files[0]);
    this.setState({
      imageSrc: base64,
    },
      () => {
        this.uploadScanImage();
      }
    );
  };

  captureImage = () => {
    this.refs.ExtraImage.click();
  }

  uploadScanImage = async () => {
    this.setState({ uploadImgLoader: true });
    const {imagesModalCurrentSourceName,imageSrc} = this.state;
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    const url = configuration.uploadScanImage;
    const payload = {
      partnerId,
      vin,
      part_name : imagesModalCurrentSourceName,
      image : imageSrc
    }
    try {
      const response = await axios.post(url,payload);
      if(response && response.data && response.data.status == 200){
          this.setState({ uploadImgLoader: false, imageSrc: "" });
          Toast.fire({
            type: "success",
            title: response.data.message,
          });
          await this.getBase64Url();
      } else{
          this.setState({ uploadImgLoader: false, imageSrc: "" });
          Toast.fire({
            type: "success",
            title: response.data.message,
          });
      }
    } catch (error) {
          this.setState({ uploadImgLoader: false, imageSrc: "" });
          Toast.fire({
            type: "error",
            title: this.lang("Something went wrong"),
          });
      
    }
  }

  render() {
    const client = localStorage.getItem("client");
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    const {
      imagesModalCurrentSourceName,
      imageIndex,
      data64Url,
      loader,
      data,
      imageName,
      uploadImgLoader
    } = this.state;
    const { partName } = this.props.location.state;
    const image_slider_settings = {
      dots: false,
      infinite: true,
      // speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      beforeChange: this.handleBeforeChange,
    };
    // const refinePartName = imagesModalCurrentSourceName ? imagesModalCurrentSourceName.split("_")[imagesModalCurrentSourceName.split("_").length - 2] : partName
    const refinePartName = imagesModalCurrentSourceName ? imagesModalCurrentSourceName : partName

    const leftSidePart = ["LeftBackFender", "LeftBackDoor", "LeftFrontDoor", "LeftFrontFender"]
    const rightSidePart = ["RightBackFender", "RightBackDoor", "RightFrontDoor", "RightFrontFender"]



    return (
      <div className="animated fadeIn">
         <input
            type="file"
            name="image"
            id="file"
            ref="ExtraImage"
            accept="image/*"
            capture="environment"
            style={{ display: "none" }}
            onChange={(e) => this.capture(e)}
          />
        <Col xs="12" sm="12">
          <Card className="print_button_card mt-2">
            <CardHeader>
              <div className="container-fluid">
                <div className="row align-items-center p-0">
                  <div className="col-lg-4 col-md-4 col-sm-12 col-12 mt-sm-10">
                    <Button
                      className="btn-danger mr-2"
                      onClick={() => this.props.history.goBack()}
                    >
                      {this.lang("Back")}
                    </Button>
                    <small>
                      {client === "SWISS" || client === "POLAND" ? (
                        <span>{this.lang("DashboardVIN")} : </span>
                      ) : (
                        <span>{this.lang("VIN Number")} : </span>
                      )}
                      {localStorage.getItem("selectedFile")}
                    </small>
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-12 col-12 mt-sm-10 p-0 text-center">
                    
                    <Button
                      className="btn-danger"
                      disabled={data && data.Authorized == true}
                      onClick={() =>
                        this.props.history.push(
                          `/dentEditor/${imagesModalCurrentSourceName}`,
                          {
                            partName: refinePartName,
                            imageName: imagesModalCurrentSourceName,
                            imageUrl: this.state.data64Url,
                            imageIndex: this.state.imageIndex
                          }
                        )
                      }
                    >
                      {this.lang("Detailed View")}
                    </Button>
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-12 col-12 mt-sm-10 p-0 text-right">
                  <Button onClick={this.captureImage} className="btn-danger" disabled={data && data.Authorized == true}>
                      {
                        uploadImgLoader ? <Spinner /> : this.lang("Replace")
                      }
                    </Button>
                  </div>
                </div>
              </div>
            </CardHeader>
          </Card>
          <Card className="m-0">
            <div className="row">
              <div className="col-12 col-sm-8">
                <div className="card m-0 details_view_wrapper">
                  <div className="card-header p-2">
                    <p>
                      {/* {`${this.lang("Report Image")} : ${this.lang(refinePartName)} - ${
                      imagesModalCurrentSourceName &&
                      imagesModalCurrentSourceName.split("_")[
                        imagesModalCurrentSourceName &&
                          imagesModalCurrentSourceName.split("_").length - 1
                      ]
                    }`} */}
                      {`${this.lang(refinePartName)}`}
                    </p>
                  </div>
                  {imageName && imageName.length > 0 ? (
                    <Slider {...image_slider_settings}>
                      {imageName.map((img_name, index) => {
                        return (
                          <div key={index} className={`position-relative ${leftSidePart.includes(partName) ? "left_side_view_details" : rightSidePart.includes(partName) ? "right_side_view_details" : ""}`}>
                            <img
                              alt={refinePartName}
                              style={{ width: "100%", cursor: "pointer" }}
                              src={data64Url}
                              onError={(img_comp) =>
                                (img_comp.target.src = DriveNscanLogo)
                              }
                            />
                          </div>
                        );
                      })}
                    </Slider>
                  ) : (
                    <div className="card-header p-2">
                      {this.lang("Image not found!")}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-12 col-sm-4">
                <div className="card">
                  <div className="card-header">
                    {this.lang("Dent Positions")}
                    <NewCarDentPositionTable
                      part={refinePartName}
                      lang={this.lang}
                      imageIndex={imageIndex}
                      loader={loader}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Card>
        </Col>
      </div>
    );
  }
}